import React, { FormEventHandler, Fragment } from 'react';
import Radio from '@mos-cat/radio';
import { Heading } from '@mos-cat/typography';
import { t, Trans } from '@lingui/macro';
import { connect } from 'dva';
import { Dispatch } from 'redux';

import { getOnChange } from '../../../helpers/handlers';
import { CHILD } from '../../../models/child';
import { CONFIRMING_DOCUMENTS } from '../../../constants/child';
import { Field } from '../../../declarations/widget-ums';
import { i18n } from '../../../helpers/i18n';
import { childConfirmingDocsSelector } from '../../../selectors/child';

interface Props {
  isVisible: boolean;
  confirmingDocs: Field<string>;
  onChange: FormEventHandler;
}

const confirmingDocumentText = {
  courtDecision: t`Решение суда о передаче ребёнка на воспитание в семью заявителя, вступившее в законную силу`,
  consent: t`Соглашение о месте проживания детей с одним из родителей`,
  indirectly: t`Документы, косвенно подтверждающие совместное проживание в вашей семье`,
};

function ChildConfirmingDocuments({
  isVisible,
  confirmingDocs,
  onChange,
}: Props): JSX.Element | null {
  if (!isVisible) return null;
  const { value, error, disabled } = confirmingDocs;
  return (
    <Fragment>
      <div className="StepContentBlock">
        <Heading level={3} className="PguFormGrid__row">
          <Trans>
            Документы, подтверждающие фактическое проживание ребёнка в семье
          </Trans>
        </Heading>
        {Object.keys(CONFIRMING_DOCUMENTS).map((name) => (
          <div className="PguFormGrid__row" key={name}>
            <Radio
              className="PguFormGrid_col"
              label={i18n._(confirmingDocumentText[name])}
              name="confirmingDocs"
              value={CONFIRMING_DOCUMENTS[name]}
              checked={value === CONFIRMING_DOCUMENTS[name]}
              error={error}
              disabled={disabled}
              onChange={onChange}
            />
          </div>
        ))}
      </div>
    </Fragment>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(CHILD, dispatch),
});

export default connect(
  childConfirmingDocsSelector,
  mapDispatchToProps
)(ChildConfirmingDocuments);
